export default __webpack_public_path__ + "static/media/sticker-wa.7563b06f.png";